<template>
  <MoleculeClearCache/>
</template>

<script>
export default {
  name: 'OrganismClearCache',

  components: {
    MoleculeClearCache: () => import('@/components/molecules/MoleculeClearCache')
  }
}
</script>
